import { motion } from 'framer-motion';
import React from 'react'
import { BiLogoDiscordAlt, BiLogoGithub } from "react-icons/bi";
import { BsLinkedin } from "react-icons/bs";
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Social = () => {


    return (
        <SocialDiv
            initial={{ scale: 0.5, opacity: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
                ease: [0.65, 0, 0.35, 1],
                duration: 1,
                delay: 1
            }}
            className='SocialDiv'>

            <Link to={"https://discordapp.com/users/759284811239784468"} target='_blank' className='icon' >
                <BiLogoDiscordAlt />
            </Link>

            <Link to={"https://github.com/Gagan-deepp"} target='_blank' className='icon'>
                <BiLogoGithub />
            </Link>

            <Link to={"https://www.linkedin.com/in/gagan-deep-singh-666158238"} target='_blank' className='icon' >
                <BsLinkedin />
            </Link>

        </SocialDiv>
    )
}

export default Social

const SocialDiv = styled(motion.div)`

`